import { LitElement } from 'lit';
export default class HelixElement extends LitElement {
    emit(name, detail, options) {
        const event = new CustomEvent(name, {
            bubbles: false,
            cancelable: false,
            composed: false,
            detail,
            ...options,
        });
        this.dispatchEvent(event);
        return event;
    }
}
//# sourceMappingURL=helix-element.js.map